var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('div',{staticClass:"error-message text-center margin-top-lg margin-bottom-lg"},[_c('h1',[_vm._v("404")]),_vm._v(" "),_c('h2',[_vm._v("We didn't find anything here.")]),_vm._v(" "),_c('a',{staticClass:"link-underline",attrs:{"title":"Go to tagboard.com","href":"https://tagboard.com"}},[_vm._v("Go to tagboard.com")])])])
}]

export { render, staticRenderFns }